import { BaseDto } from "src/dtos/common/baseDto";

export interface TqcTestHdrDto extends BaseDto {
	testResultNo: string;
	compCd: string;
	platingType: string;
	testDt: string;
	testNm: string;
	empNo: string;
	empNm: string;
	itemNo: string;
	itemNm: string;
	carModel: string;
	customCd: string;
	lotNo: string;
	testFrdt: string;
	testTodt: string;
	equipmentCd: string;
	equipmentNm: string;
	testClass: string;
	resultCondition: string;
	sampleCount: number;
	resultValue: string;
	beforeImage: string;
	afterImage: string;
	remark: string;

	inserted: boolean;
	isModified: boolean;
}

export const defaultTqcTestHdrDto: TqcTestHdrDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	testResultNo: '',
	compCd: '',
	platingType: '',
	testDt: '',
	testNm: '',
	empNo: '',
	empNm: '',
	itemNo: '',
	itemNm: '',
	carModel: '',
	customCd: '',
	lotNo: '',
	testFrdt: '',
	testTodt: '',
	equipmentCd: '',
	equipmentNm: '',
	testClass: '',
	resultCondition: '',
	sampleCount: 0,
	resultValue: '',
	beforeImage: '',
	afterImage: '',
	remark: '',

	inserted: false,
	isModified: false,
};

export interface TqcTestDtlDto extends BaseDto {
	testResultNo: string;
	testItemNo: string;
	sampleInfo: string;
	testSeq: number;
	testValue: string;
	remark: string;

	autoCompletedSampleInfo?: string;

	inserted: boolean;
	isModified: boolean;
}

export const defaultTqcTestDtlDto: TqcTestDtlDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	testResultNo: '',
	testItemNo: '',
	sampleInfo: '',
	testSeq: 0,
	testValue: '',
	remark: '',

	inserted: false,
	isModified: false,
};
